import { render, staticRenderFns } from "./CarSaleContent.vue?vue&type=template&id=220072de&"
import script from "./CarSaleContent.vue?vue&type=script&lang=js&"
export * from "./CarSaleContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports